import React from "react";
import { Box, Typography } from "@mui/material";
import { DestinationAbbreviated } from "@/types/dto/destinations-page/destination-page-types";
import ArrowIcon from "@/components/common/icons/arrow-icon";
import { injectSourceIntoUrl } from "@/config/unified-search-config";

interface CardStyles {
  height: number | Record<string, number>;
  borderRadius: string | Record<string, string>;
  gradient: string | Record<string, string>;
}
interface RelatedCardProps {
  destination: DestinationAbbreviated;
  getCardStyles: () => CardStyles;
  arrowIconFlag?: boolean;
}

const RelatedCard: React.FC<RelatedCardProps> = ({ destination, getCardStyles, arrowIconFlag = true }) => {
  const buttonItemUrl = destination.url
    ? injectSourceIntoUrl(destination.url, "destinations_related_tours_url")
    : "";
  return (
    <Box
      component="a"
      href={buttonItemUrl}
      sx={{
        display: "flex",
        height: getCardStyles().height,
        padding: "2rem",
        alignItems: "flex-end",
        gap: "1rem",
        flex: {
          xs: "1 0 100%",
          sm: "1 0 calc(50% - 8px)",
          md: "1 0 calc(33.333% - 10.67px)",
          lg: "1 0 0"
        },
        borderRadius: getCardStyles().borderRadius,
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        textDecoration: "none",
        backgroundImage: `url(${destination.imageUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "background.warm_strong",
        "&::before": {
          content: "\"\"",
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: getCardStyles().gradient,
          pointerEvents: "none"
        },
        transition: "transform 0.3s ease-in-out",
        "&:hover": {
          transform: "scale(1.02)"
        }
      }}
    >
      {/* Destination Name and Arrow */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          zIndex: 1
        }}
        data-testid="related-destination-card"
      >
        <Typography
          variant="h5"
          component="p"
          sx={{
            flex: "1 0 0",
            color: "common.white"
          }}
        >
          {destination.name}
        </Typography>
        {arrowIconFlag && <ArrowIcon />}
      </Box>
    </Box>
  );
};

export default RelatedCard;

